import { useState } from "react";
import LogTypesSCP from "../../../../../../Services/Data/SCP/LogTypesSCP";
import LogRenderTypesSCP from "../../../../../../Services/Data/SCP/LogRenderTypesSCP";
import { GetTimeDifference } from "../../../../../../Services/DateManager/DateManager";
import "./LogSCP.css";
import HideShowField from "../../../../../../Components/HideShowField/HideShowField";

const LogSCP = ({log}) => {
    const columns = JSON.parse(log.content);
    
    const date = new Date(Date.parse(log.logDate));
    const now = Date.now();

    const difference = GetTimeDifference(date, now);

    const logType = LogTypesSCP[log.logType];

    const renderFields = (column, field) => {
        return (
            <div className="serverLogField">
                { field.Name &&
                    <p className="text-glwhite-600">{field.Name.replace("_", " ").replace(/([A-Z])/g, ' $1')}:</p>
                }
                
                { !field.IsSensitiveData &&
                    LogRenderTypesSCP[field.RenderType].render(field)
                }

                { field.IsSensitiveData &&
                    <HideShowField field={field}/> 
                }                                      
            </div>
        )
    }

    return (
        <div className="serverLog">
            <div className="p-3 gap-4">
                { !logType?.customRender &&
                    <>
                        <div className="serverLogTitle">
                            { logType?.getIcon() }
                            <h3 className="m-0">{ logType?.name }</h3>
                        </div>
                        <div className="flex">
                            { columns.map((column) => 
                                <>
                                    { column.Fields.length > 0 &&
                                        <div className="flex-1">
                                            { column &&
                                                <h3 className="mt-3">{column.Name}</h3>
                                            }
                                            
                                            { column.Fields.map(field => 
                                                renderFields(column, field)
                                            )}
                                        </div>
                                    }
                                </>
                            )}
                        </div>
                    </>
                }

                { logType?.customRender && 
                    logType?.customRender()
                }
            </div>
            <div className="serverLogFooter">
                {date.toLocaleTimeString("pl-PL")} {date.toLocaleDateString("pl-PL")} [{difference} ago]
            </div>
        </div>
    )
}

export default LogSCP;